import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { LenticMark } from '../LenticMark';
import { EYEBROW } from './Band';
const pilotIncludes = ['One live requisition', 'Up to five candidates', 'Bespoke scenario build', 'Decision Record for every participant', 'Human governance review'];
export function Contact() {
  return <section id="contact" className="relative w-full scroll-mt-20 overflow-hidden border-b border-mist bg-bone" data-id="element-53" data-mp="36rgd9eykxmiv">
      <div className="pointer-events-none absolute -bottom-40 -left-32 opacity-[0.12]" data-id="element-54" data-mp="78nqlma371cn">
        <LenticMark size={520} title={null} data-id="element-55" data-mp="39y49472m9gv" />
      </div>

      <div className="relative mx-auto w-full max-w-6xl px-6 py-20 lg:px-10 lg:py-28" data-id="element-56" data-mp="3ueohdtk9upjb">
        <div data-id="element-57" data-mp="3pgwds2a9leza">
          <p className={`${EYEBROW} text-teal`} data-id="element-58" data-mp="3ph64js34vq61">Get started</p>
          <h2 className="mt-5 max-w-xl font-display text-[34px] font-light leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-59" data-mp="2j0ax0yoq8s81">
            Run your first requisition through Lentic.
          </h2>

          <p className="mt-6 max-w-[60ch] text-lg leading-relaxed text-graphite" data-id="element-60" data-mp="2t6buzcj0ki8q">
            A controlled pilot for one live role. See the assessment, observe
            the candidate session and receive the Decision Records yourself.
          </p>

          <div className="mt-10 rounded-2xl border border-ink/15 bg-white/70 p-8" data-id="element-61" data-mp="2j7cifiv4o2gg">
            <h3 className={`${EYEBROW} text-teal`} data-id="element-62" data-mp="2o6fn327746nw">
              Pilot programmes available
            </h3>
            <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-63" data-mp="29h9qllzqsujp">
              {pilotIncludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-64" data-mp="2e9b4fcck6tbu">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-65" data-mp="20hmnmvrd7goj" />
                  <span className="text-[15px] leading-snug text-ink" data-id="element-66" data-mp="25gqzxv9l5uj3">{item}</span>
                </li>)}
            </ul>
            <p className="mt-6 border-t border-mist pt-5 text-[15px] leading-relaxed text-graphite" data-id="element-67" data-mp="1qiylz7jote70">
              Billed as a professional service. No security review, no ATS
              integration, no IT dependency. Twelve working days from role spec
              to live assessment.
            </p>
          </div>

          <div className="mt-9 flex flex-wrap items-center gap-4" data-id="element-68" data-mp="17m6qzogjnw2j">
            <a href="mailto:hello@lentic.ai?subject=Lentic%20walkthrough" className="inline-flex items-center gap-2 rounded-full bg-teal px-7 py-4 text-base font-semibold text-bone transition-colors hover:bg-teal-deep" data-id="element-69" data-mp="12nvgrcmc7jjs">
              Book a walkthrough
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-70" data-mp="1vc1509clnqod" />
            </a>
            <a href="#record" className="inline-flex items-center gap-2 rounded-full border border-ink/15 px-7 py-4 text-base font-semibold text-ink transition-colors hover:border-ink/40" data-id="element-71" data-mp="1qf0v1ncmq3rz">
              See what's in a Decision Record
            </a>
          </div>
        </div>

      </div>
    </section>;
}